import { Timeslot } from "@platform/features/timeslots/timeslots.types";

export function groupTimeslotsByDay(timeSlots: Timeslot[]) {
  const grouped: Record<number, Timeslot[]> = {};

  for (const slot of timeSlots) {
    if (!grouped[slot.local.start.dayIndex]) {
      grouped[slot.local.start.dayIndex] = [];
    }
    grouped[slot.local.start.dayIndex].push(slot);
  }

  return grouped;
}

export default groupTimeslotsByDay;
